import React from "react";

const NotFound = () => (
  <div className="no-timetable-header">
    <div className="no-timetable">No Timetable Available</div>
  </div>
);

export default NotFound;